<template>
  <span>
    <b-button @click="handleClickAddProfile" variant="-primary">{{$t('profiles.buttons.addProfile')}}</b-button>
    <slicer3 v-if="slicer3Show" :show="slicer3Show" @hide="slicer3Show = false" profile-mode></slicer3>
  </span>
</template>

<script>
  import Slicer3 from "../apps/slicer3/Slicer3";

  export default {
    name: 'slicing-profile-add-button',
    components: {Slicer3},
    data() {
      return {
        slicer3Show: false
      }
    },

    methods: {
      handleClickAddProfile() {
        this.slicer3Show = true;
      }
    }
  }
</script>
